<template>
  <div>
    <el-dialog
      :title="$t('Məsul_şəxs')"
      :visible.sync="showModal"
      width="30%"
      top="30vh"
      append-to-body
      :close-on-press-escape="false" 
      :close-on-click-modal="false" 
    >
      <legal-expert-users v-model="legalExpertUid" />
      <span slot="footer" class="dialog-footer">
      
        <el-button size="small" type="primary" @click="clickSave">{{$t('Yadda_saxla')}}</el-button>
        <el-button size="small" @click="showModal = false">{{$t('İmtina')}}</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import LegalExpertUsers from "../components/LegalExpertUsers.vue";
import { LegalExpertUserUpdate } from "../../services/claim";
export default {
  components: {
    LegalExpertUsers,
  },
  data() {
    return {
      showModal: false,
      item: {},
      legalExpertUid: null,
      uid: this.$store.state.user.id,
    };
  },
  methods: {
    edit(item) {
      this.item = item;
      this.showModal = true;
    },
    clickSave() {
      LegalExpertUserUpdate(this.item.id, this.legalExpertUid,this.uid).then(
        (response) => {
          if (response.data.data) {
            if (!response.data.isSuccess) {
              this.$message({
                type: "error",
                message: response.data.errors[0]
                  ? response.data.errors[0]
                  : this.$t('Səhv_əməliyyat'),
              });
            } else {
              this.$emit("refresh-table");
              this.showModal = false;
              this.$message({
                type: "success",
                message: this.$t('Uğurlu_əməliyyat'),
              });
            }
          } else {
            this.$message({
              type: "error",
              message: this.$t('Səhv_əməliyyat'),
            });
          }
        }
      );
    },
  },
};
</script>

<style scoped>
</style>
